import React, { useEffect, useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	// FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Skeleton from '@material-ui/lab/Skeleton';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/busnew.svg';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import flightpro from '../../assets/images/flightpro.png';
import FlightDetailModal from '../../components/reusableComponents/FlightDetailModal';
import { setFlightId, toggleFlightModal } from '../../reducers/UiReducer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { useHistory, useLocation } from 'react-router-dom';
import { SearchFormDispatch } from '../../reducers/HomeReducer';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
// import OnewayForm from '../../form/OnewayForm';
import BusListForm from '../../form/BusListForm';
import { Divider } from '@mui/material';
import { Showseat } from './ShowSeat';
import SearchItem from './SearchItem';
import HotelModifyForm from '../../form/HotelModifyForm';

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-evenly',
		},
	},
	searhform: {
		// backgroundImage: `url(${Home})`,
		background: 'rgb(34, 118, 227)',
		// height: 272,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',

		paddingTop: 66,

		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
	radio: {
		'& .MuiTypography-body1': {
			fontSize: 13,
		},
	},
	scroll: {
		'&::-webkit-scrollbar': {
			width: '0.2em',
		},
		'&::-webkit-scrollbar-track': {
			// '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'rgba(0,0,0,.1)',
			outline: '1px solid slategrey',
			// borderTopLeftRadius: 5,
			// borderTopRightRadius: 5,
			borderRadius: 5,
		},
	},
}));

const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const HotelList = () => { 
	const classes = useStyles();
	const dispatch = useDispatch();
	const [expanded, setExpanded] = React.useState('');
	const [check, setCheck] = useState(false);
	const [check2, setCheck2] = useState(false);
	const [check3, setCheck3] = useState(false);
	const [check4, setCheck4] = useState(false);
	const [check5, setCheck5] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [scrollValResult, SetScrollValResult] = useState(10);
	const [hasMoreresult, SethasMoreResult] = useState(true);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const [result, setResult] = useState([]);
	const history = useHistory();
	const theme = useTheme();
	const location = useLocation();
	const { search, loading } = useSelector((state) => state.home);
	const { filterDataR } = useSelector((state) => state.ui);
	const [stop1, setStop1] = useState(false);
	const [value, setValue] = React.useState([1000, 5000]);

	const [stop2, setStop2] = useState(false);
	const [stop3, setStop3] = useState(false);
	const [ac, setAC] = useState(false);
	const [nonac, setNAC] = useState(false);
	const [seater, setSeater] = useState(false);
	const [sleeper, setSleeper] = useState(false);
	const [morning, setMorning] = useState(false);
	const [dophar, setDOphar] = useState(false);
	const [toggle, setToggle] = useState(false);
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSlider = (event, newValue) => {
		setValue(newValue);
		console.log(newValue);
		let checkData = [];
		if (search && newValue) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					let a = item.Fare.BaseFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData.push({
							...item,
						});
					}
				});
		}

		setResult(checkData);
		SetScrollValResult(10);
		console.log('Slider Value', checkData);
	};
	const handleCheck = (event) => {
		setCheck(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckGO = (event) => {
		setCheck2(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckIndigo = (event) => {
		setCheck3(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckAir = (event) => {
		setCheck4(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check4) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleCheckVistara = (event) => {
		setCheck5(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		if (search && event.target.name) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
		}
		console.log(checkData);
		if (check5) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(...result, checkData);
		}
	};
	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	function valuetext(value) {
		return `${value}°C`;
	}
	function display(a) {
		var hours = Math.trunc(a / 60);
		var minutes = a % 60;
		console.log(hours + ':' + minutes);
	}
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log(location.state);
	let filterData = [];
	filterData =
		search &&
		search.data &&
		search.data.Response &&
		search.data.Response.Results[0].length > 0 &&
		search.data.Response.Results[0].slice().sort((a, b) => {
			return a.Fare.BaseFare - b.Fare.BaseFare;
		});
	console.log('fILTER', filterData);

	const fetchMoreData = () => {
		if (scrollVal >= filterData.length) {
			SethasMoreFilterData(false);
		}

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const fetchMoreDataResult = () => {
		if (scrollValResult >= filterData.length) {
			SethasMoreResult(false);
		}
		setTimeout(() => {
			SetScrollValResult(scrollValResult + 5);
		}, 500);
	};

	useEffect(() => {
		if (location.state) {
			dispatch(SearchFormDispatch(location.state.body, history));
		}
	}, [dispatch]);

	const handleOne = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 1) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (stop1) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
	};
	const handleTwo = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 2) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		setResult(checkData);
		if (stop2) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
	};
	const handleThree = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 3) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		setResult(checkData);
		if (stop3) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
	};
	const handlemorning = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (morning) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Morning', checkData);
	};
	const handledophar = () => {
		let checkData = [];
		if (search) {
			search &&
				search.data &&
				search.data.Response &&
				search.data.Response.Results[0].length > 0 &&
				search.data.Response.Results[0].map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (dophar) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}
		console.log('Dophar', checkData);
	};

	console.log(location.state);
	console.log(result);
	console.log(scrollVal);
	return (
		<>
			<header className='header'>
				<a  className='logo'>
					<img
						src='https://www.marinersforex.com/img/LOGO-MarinersForex.png'
						width='200px'
                        style={{cursor:'pointer'}}
						height='50px'
						onClick={() => history.push('/')}></img>
				</a>
				<Hidden only={['xs']}>
					<Box display='flex'>
						{/* <Box
							display='flex'
							alignItems='center'
							onClick={() => history.push('/home')}>
							<img
								src={flightnew}
								style={{
									filter:
										' invert(46%) sepia(45%) saturate(4226%) hue-rotate(348deg) brightness(96%) contrast(91%)',
								}}></img>
							<TitleText four textStyle={{ color: '#EC5B25' }}>
								Flights
							</TitleText>
						</Box> */}
						{/* <Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/new')}>
							<img src={trainnew}></img>
							<TitleText four>Trains</TitleText>
						</Box> */}
						{/* <Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/buses')}>
							<img src={busnew}></img>
							<TitleText four>Buses</TitleText>
						</Box>
						<Box display='flex' alignItems='center' ml={'30px'}>
							<img src={hotelnew}></img>
							<TitleText four>Hotels</TitleText>
						</Box> */}
					</Box>
				</Hidden>

				{/* <div className='icons'>
					<div className='fas fa-moon' id='theme-btn'></div>
					<div
						className='fas fa-user'
						id='login-btn'
						onClick={() => history.push('/agent')}></div>
					<div
						className='fas fa-bars'
						id='menu-btn'
						onClick={() => {
							let loginForm = document.querySelector('.login-form');
							let navbar = document.querySelector('.navbar');
							loginForm.classList.toggle('active');
							navbar.classList.remove('active');
						}}></div>
				</div> */}

				<nav className='navbar'>
					<a href='#home'>home</a>
					<a href='#packages'>packages</a>
					<a href='#services'>services</a>
					<a href='#pricing'>pricing</a>
					<a href='#review'>review</a>
					<a href='#contact'>contact</a>
					<a href='#blogs'>blogs</a>
				</nav>

				<form action='' className='login-form'>
					<div className='inputBox'>
						<span>username</span>
						<input type='text' placeholder='enter your name' />
					</div>

					<div className='inputBox'>
						<span>password</span>
						<input type='password' placeholder='enter your password' />
					</div>

					<div className='remember'>
						<input type='checkbox' name='' id='login-remember' />
						<label for='login-remember'>remember me</label>
					</div>

					<input type='submit' className='btn' value='login' />
				</form>
			</header>

			<Box
				className={classes.searhform}
				style={{ backgroundPosition: matches2 ? '' : '1px -443px' }}>
				<Container>
					<HotelModifyForm/>
				</Container>
			</Box>
            <Container style={{marginTop:50}}>
            <Grid container>
            <Grid item xs={4}>

            </Grid>
            <Grid item xs={8}>
               {[0,1,2,3].map((item,index)=>{
                return  <SearchItem/>
               })}
            </Grid>
        </Grid>
            </Container>
		
			<FlightDetailModal />
			<Drawers />
			<Login />
		</>
	);
};

export default HotelList;
